
const noProviderError = (providerToken: string) => {
  throw new Error(`BACKOFFICE_ERROR: no provider for ${providerToken}.`);
};

const noProviderWarning = (providerToken: string, defaultValue: any) => {
  console.warn(`BACKOFFICE_WARNING: no provider for ${providerToken}, default value ${defaultValue} will be used.`);
};

const requiredModuleError = (moduleName: string) => {
  throw new Error(`BACKOFFICE_ERROR: ${moduleName} module was not imported. It is required for backoffice.`);
};

const formRegistryError = (formName: string) => {
  throw new Error(`BACKOFFICE_ERROR: no form was found in FORM_REGISTRY for ${formName}.`);
};


export {
  noProviderError,
  noProviderWarning,
  requiredModuleError,
  formRegistryError,
};
